let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g69Gk")).then(() => parcelRequire('hs5Yt'));